import postWithToken from "./base/post-with-token";

const switchTenant = (id) => postWithToken(`/tenant/switch`)({ id });

export default switchTenant;
